import React, { useEffect } from 'react';
import ChartJs from 'chart.js';
import styled from 'styled-components';

const ChartContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 220px;
  font-size: 11px;
  overflow: hidden;

  canvas {
    max-width: 100%;
  }
`;

const initChart = (id, chile) => {
  const elem = document.getElementById(id);
  if (!elem) {
    return;
  }

  const canvasId = `${id}_canvas`;
  elem.innerHTML = `<canvas id="${canvasId}"></canvas>`;
  const ctx = document.getElementById(canvasId).getContext('2d');
  new ChartJs(ctx, {
    type: 'bar',
    data: {
      datasets: [
        {
          data: [15, chile, 9, 4.5, 2.1],
          backgroundColor: '#639fed',
          label: 'Emisiones per cápita',
        }
      ],
      labels: ['USA', 'Chile', 'OCDE', 'Mundo', 'América No-OCDE'],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
        labels: {
          boxWidth: 15,
          padding: 10,
        },
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: '#eeeeee',
          },          
        }],
        yAxes: [
          {
            id: 'y-axes',
            stacked: false,
            scaleLabel: {
              display: true,
              labelString: 'Millón de ton. de CO2e',
            },
            ticks: {
              suggestedMin: 0,
              suggestedMax: 20,
              stepSize: 5,
            },
            gridLines: {
              color: '#eeeeee',
            },
          },
        ],
      },
    },
  });
};

/**
 * Gráfico de emisiones per capita 
 */
const EmisionesChart = ({ chile }) => {
  const id = `kpi_chart_${String(chile).replace('.', '_')}`;

  useEffect(() => {
    initChart(id, chile);
  }, [id, chile]);

  return (
    <ChartContainer id={id} />
  )
}

export default EmisionesChart;
